import { render, staticRenderFns } from "./periodList.vue?vue&type=template&id=0cbc0b7a&scoped=true"
import script from "./periodList.vue?vue&type=script&lang=js"
export * from "./periodList.vue?vue&type=script&lang=js"
import style0 from "./periodList.vue?vue&type=style&index=0&id=0cbc0b7a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbc0b7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/deduct_saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cbc0b7a')) {
      api.createRecord('0cbc0b7a', component.options)
    } else {
      api.reload('0cbc0b7a', component.options)
    }
    module.hot.accept("./periodList.vue?vue&type=template&id=0cbc0b7a&scoped=true", function () {
      api.rerender('0cbc0b7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/periodList.vue"
export default component.exports